/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecoveringStockQuantityDetails } from '../../models/recovering-stock-quantity-details';

export interface MgmtRecoveringStockControllerGetQuantityDetails$Params {
  id: number;
}

export function mgmtRecoveringStockControllerGetQuantityDetails(http: HttpClient, rootUrl: string, params: MgmtRecoveringStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringStockQuantityDetails>> {
  const rb = new RequestBuilder(rootUrl, mgmtRecoveringStockControllerGetQuantityDetails.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveringStockQuantityDetails>;
    })
  );
}

mgmtRecoveringStockControllerGetQuantityDetails.PATH = '/api/mgmt/recovering-stock/{id}/quantity-details';
